import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import {ColorThumb as $ebb08d0afd4c10ba$export$a3cc47cee1c1ccc} from "./ColorThumb.mjs";
import {dimensionValue as $63d03c54ca5e4b88$export$abc24f5b99744ea6, useStyleProps as $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41} from "../utils/styleProps.mjs";
import "../colorwheel_vars.css";
import $jYwsr$colorwheel_vars_cssmjs from "../colorwheel_vars_css.mjs";
import {useFocusableRef as $3c2c983d5210446c$export$96a734597687c040} from "../utils/useDOMRef.mjs";
import {useProviderProps as $71dfb0e0358a12de$export$521c373ccc32c300} from "../provider/Provider.mjs";
import {useColorWheel as $jYwsr$useColorWheel} from "react-aria/useColorWheel";
import {ColorWheelContext as $jYwsr$ColorWheelContext} from "react-aria-components/ColorWheel";
import $jYwsr$react, {useRef as $jYwsr$useRef, useState as $jYwsr$useState, useCallback as $jYwsr$useCallback} from "react";
import {useColorWheelState as $jYwsr$useColorWheelState} from "react-stately/useColorWheelState";
import {useContextProps as $jYwsr$useContextProps} from "react-aria-components/slots";
import {useFocusRing as $jYwsr$useFocusRing} from "react-aria/useFocusRing";
import {useLayoutEffect as $jYwsr$useLayoutEffect} from "react-aria/private/utils/useLayoutEffect";
import {useResizeObserver as $jYwsr$useResizeObserver} from "react-aria/private/utils/useResizeObserver";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 













const $37ba4dcb2e5337d9$var$WHEEL_THICKNESS = 24;
const $37ba4dcb2e5337d9$export$f80663f808113381 = /*#__PURE__*/ (0, $jYwsr$react).forwardRef(function ColorWheel(props, ref) {
    props = (0, $71dfb0e0358a12de$export$521c373ccc32c300)(props);
    let inputRef = (0, $jYwsr$useRef)(null);
    let containerRef = (0, $3c2c983d5210446c$export$96a734597687c040)(ref, inputRef);
    [props, containerRef] = (0, $jYwsr$useContextProps)(props, containerRef, (0, $jYwsr$ColorWheelContext));
    let { isDisabled: isDisabled } = props;
    let size = props.size && (0, $63d03c54ca5e4b88$export$abc24f5b99744ea6)(props.size);
    let { styleProps: styleProps } = (0, $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41)(props);
    let [wheelRadius, setWheelRadius] = (0, $jYwsr$useState)(0);
    let [wheelThickness, setWheelThickness] = (0, $jYwsr$useState)($37ba4dcb2e5337d9$var$WHEEL_THICKNESS);
    let resizeHandler = (0, $jYwsr$useCallback)(()=>{
        if (containerRef.current) {
            setWheelRadius(containerRef.current.offsetWidth / 2);
            let thickness = window.getComputedStyle(containerRef.current).getPropertyValue('--spectrum-colorwheel-track-thickness');
            if (thickness) setWheelThickness(parseInt(thickness, 10));
        }
    }, [
        containerRef,
        setWheelRadius,
        setWheelThickness
    ]);
    (0, $jYwsr$useLayoutEffect)(()=>{
        // the size observer's fallback to the window resize event doesn't fire on mount
        if (wheelRadius === 0) resizeHandler();
    }, [
        wheelRadius,
        resizeHandler
    ]);
    (0, $jYwsr$useResizeObserver)({
        ref: containerRef,
        onResize: resizeHandler
    });
    let state = (0, $jYwsr$useColorWheelState)(props);
    let { trackProps: trackProps, inputProps: inputProps, thumbProps: thumbProps } = (0, $jYwsr$useColorWheel)({
        ...props,
        innerRadius: wheelRadius - wheelThickness,
        outerRadius: wheelRadius
    }, state, inputRef);
    let { focusProps: focusProps, isFocusVisible: isFocusVisible } = (0, $jYwsr$useFocusRing)();
    return /*#__PURE__*/ (0, $jYwsr$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($jYwsr$colorwheel_vars_cssmjs))), 'spectrum-ColorWheel', {
            'is-disabled': isDisabled
        }, styleProps.className),
        ref: containerRef,
        style: {
            ...styleProps.style,
            // Workaround around https://github.com/adobe/spectrum-css/issues/1032
            'width': size,
            'height': size
        }
    }, /*#__PURE__*/ (0, $jYwsr$react).createElement("div", {
        ...trackProps,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($jYwsr$colorwheel_vars_cssmjs))), 'spectrum-ColorWheel-gradient')
    }), /*#__PURE__*/ (0, $jYwsr$react).createElement((0, $ebb08d0afd4c10ba$export$a3cc47cee1c1ccc), {
        value: state.getDisplayColor(),
        isFocused: isFocusVisible,
        isDisabled: isDisabled,
        isDragging: state.isDragging,
        containerRef: containerRef,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($jYwsr$colorwheel_vars_cssmjs))), 'spectrum-ColorWheel-handle'),
        ...thumbProps
    }, /*#__PURE__*/ (0, $jYwsr$react).createElement("input", {
        ...focusProps,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($jYwsr$colorwheel_vars_cssmjs))), 'spectrum-ColorWheel-slider'),
        ...inputProps,
        ref: inputRef
    })));
});


export {$37ba4dcb2e5337d9$export$f80663f808113381 as ColorWheel};
//# sourceMappingURL=ColorWheel.mjs.map
